import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1002Model } from '../kymw1002.model';
import { CautionErrorListModel, MessageInfoListModel, ProcessControlListModel } from "../vo/dashboard-message-info.model";

/**
 * ダッシュボード画面各種メッセージを取得するサービス
 *
 * @export GetDashboardMessageService
 * @class GetDashboardMessage
 * @extends {PlessResponder}
 */
@Injectable()
export class GetDashboardMessageService extends PlessJsonResponderSub<any> {
  private model: KYMW1002Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDashboardMessageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserId: this.vo.userId,
        MessageShowDate: this.vo.messageShowDate
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1002Model} model モデルクラス
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetDashboardMessageService
   */
  execute(model: KYMW1002Model, vo: any, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getDashboardMessage', this.getBody());
  }


  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetDashboardMessageService
   */
  success(data: any): void {
    this.model.dashboardMessageInfoList.ProcessControlList = data.ProcessControlList.map(data => new ProcessControlListModel(
      data.PCMessage,
      data.PCFormId
    ));
    this.model.dashboardMessageInfoList.CautionErrorList = data.CautionErrorList.map(data => new CautionErrorListModel(
      data.CEMessage,
      data.CEFormId
    ));
    this.model.dashboardMessageInfoList.MessageInfoList = data.MessageInfoList.map(data => new MessageInfoListModel(
      data.MIMessage,
      data.MIFormId
    ));

    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetDashboardMessageService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
